export default __webpack_public_path__ + "static/media/notification_following.776cd88c.svg";